import React from 'react'
import { Form, Input } from 'antd'

const FormInput = props => {
  const { name, label, labelAlign = 'left', validation, disabled } = props

  return (
    <Form.Item
      name={name}
      label={label}
      labelAlign={labelAlign}
      rules={validation}
    >
      <Input disabled={disabled} />
    </Form.Item>
  )
}

export default FormInput
